import { createSelector } from 'reselect';
import GridFiltersTypes from '../types/GridFiltersType';
import { maxRowDataTable } from '../../utils/Constants';

export const initialStateList = {
  data: [],
  page: 0,
  maxRows: 0,
  rows: 0,
  hasMore: false,
  filtersHavedChanged: false,
  filters: [],
  columnsOrder: {},
  columns: [],
};

export const listData = (state, responseData, fromBackButton) => {
  const { data: records = [], maxRows, ...rest } = responseData;
  const { filtersHavedChanged } = state;

  let data = Array.from(state.data).concat(records);
  const rows = data.length >= maxRowDataTable ? maxRows - 1 : responseData.rows;
  const page = records.length ? state.page + 1 : state.page;
  if (filtersHavedChanged || fromBackButton) {
    data = records;
  }
  return {
    ...state,
    ...rest,
    data,
    page,
    maxRows,
    filtersHavedChanged: false,
    hasMore: rows === maxRows,
  };
};

const setColumnVisibility = ({ columns: allColumns, ...state }, columnName, visible) => {
  const columns = allColumns.map((column) => {
    if (column.name === columnName) return { ...column, visible };
    return column;
  });
  return { ...state, columns };
};

const setColumns = (list, allColumns) => {
  let order = 0;
  const columns = Object.keys(allColumns).reduce((cols, name) => {
    cols.push({ name, visible: allColumns[name], order });
    order += 1;
    return cols;
  }, []);
  return { ...list, columns };
};

const setFiltersList = (list, filters) => {
  const newList = { page: 0, data: [], filtersHavedChanged: true, filters };
  return { ...list, ...newList };
};

const hasList = (state, list) => {
  return state[list];
};

export const GridFilters = {
  [GridFiltersTypes.actions.setGridFilters]: (state, { payload: { list, filters } }) =>
    hasList(state, list)
      ? {
          ...state,
          [list]: setFiltersList(
            state[list],
            filters.filter((filter) => filter.value)
          ),
        }
      : state,
  [GridFiltersTypes.actions.setGridColumns]: (state, { payload: { list, allColumns } }) =>
    hasList(state, list)
      ? {
          ...state,
          [list]: setColumns(state[list], allColumns),
        }
      : state,
  [GridFiltersTypes.actions.setColumnVisibility]: (state, { payload: { list, column, visibility } }) =>
    hasList(state, list)
      ? {
          ...state,
          [list]: setColumnVisibility(state[list], column, visibility),
        }
      : state,
  [GridFiltersTypes.actions.fetchGridFiltersSuccess]: (state, { payload: { list, responseData, fromBackButton } }) =>
    hasList(state, list)
      ? {
          ...state,
          [list]: listData(state[list], responseData, fromBackButton),
        }
      : state,
};

export const getCurrentPage = createSelector((list) => list.page);

export const getRecords = (list) => list.data;

export const getCountRecords = (list) => list.data.length;

export const getMaxRows = (list) => list.maxRows;

export const getPage = (list) => list.page;

export const getShowColumns = ({ columns }) => columns.filter((column) => column.visible).map(({ name }) => name);

export const getHideColumns = ({ columns }) => columns.filter((column) => !column.visible).map(({ name }) => name);

export const getOrderedColumns = ({ columns }) => columns.map(({ name, visible }) => ({ name, visible }));

export const hasMore = (list) => list.rows === list.maxRows;

export const getFilters = ({ filters }) => {
  const allFilters = filters.filter(({ value }) => value != null).reduce((fs, { filter, value }) => ({ ...fs, [filter]: value }), {});
  return {
    ...allFilters,
  };
};

export const getRequestToFetch = ({ page, filters }, fromBackButton) => {
  const allFilters = getFilters({ filters });
  return {
    page: fromBackButton ? 0 : page,
    ...allFilters,
    // @TODO review how to send de order columns
    // order: 'columnsOrder'
  };
};
